<template>
  <div
    class="title q-ma-sm"
    :class="{ 'drag-over': dragOver, 'dragging': dragging, 'cursor-pointer': editable, 'small': size === 'sm' }"
    style="border-radius: 4px; overflow: hidden; position: relative;"
    :style="{
      'background-color': (bookingWeekMovie.planElement.color + '33'),
      'border': ('solid 2px ' + bookingWeekMovie.planElement.color)
    }"
    dropzone
    @dragover.prevent
    @dragenter="editable && dragEnter()"
    @dragleave="editable && dragLeave()"
    @dragend="editable && dragEnd()"
    @drop="editable && drop()"
    @click="editable && $emit('title-click', bookingWeekMovie)"
    @dblclick="editable && $emit('title-double-click', bookingWeekMovie)"
  >
    <div
      v-if="bookingWeekMovie"
    >
      <q-img
        v-if="movie"
        basic
        class="poster"
        draggable
        style="z-index: 0;"
        :src="movie.posterImageUrl"
        @dragstart="editable && dragStart()"
      />
    </div>
    <div
      class="title-count"
      style="pointer-events: none; z-index: 1; position: absolute; top: 5px; left: 5px; background-color: #FFF; border: none;"
      :class="{ 'small': size === 'sm' }"
    >
          &nbsp;
    </div>
    <div
      class="title-count"
      :class="{ 'small': size === 'sm' }"
      style="pointer-events: none; z-index: 1; position: absolute; top: 5px; left: 5px;"
      :style="'color: ' + bookingWeekMovie.planElement.color + '; border-color: ' + bookingWeekMovie.planElement.color + '; background-color: ' + bookingWeekMovie.planElement.color + '33;'"
    >
      {{ bookingWeekMovie.priorityOrder + 1 }}
    </div>
    <q-tooltip v-if="movie && movie.name">
      <div class="text-h6">
        {{ movie.name }}
      </div>
      <div
        v-if="movie.releaseDate"
        class="text-caption"
      >
        {{ movie.releaseDate.i18n('date') }}
      </div>
      <showing-badge
        v-for="showingBadge in movie.showingBadges.data"
        :key="showingBadge.id"
        :showing-badge="showingBadge"
        solid
      />
    </q-tooltip>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'

export default {
  name: 'TitleSlot',
  components: {
    ShowingBadge
  },
  props: {
    bookingWeekMovie: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  emits: ['title-click', 'title-double-click', 'drag-start', 'drag-end'],
  data () {
    return {
      dragging: false,
      dragOver: 0
    }
  },
  computed: {
    editable () {
      return !this.readOnly
    },
    movie () {
      return this.bookingWeekMovie.movie
    }
  },
  methods: {
    dragStart () {
      this.$emit('drag-start', this.bookingWeekMovie)

      // Use set timeout because we want the drag bitmap to be the version prior to adding the dragging class
      setTimeout(() => { this.dragging = true }, 0)
    },
    dragEnd () {
      this.dragging = false
    },
    drop () {
      this.$emit('drag-end', this.bookingWeekMovie)
      this.dragOver = 0
    },
    dragEnter () {
      this.dragOver += 1
    },
    dragLeave () {
      this.dragOver -= 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    width: 100px;
    height: 145px;
    transition: all 0.1s;
  }
  .title.drag-over {
    width: 115px;
    height: 160px;
    margin: 0px;
  }

  .title.small {
    width: 40px;
    height: 55px;
  }

  .title-count {
    display: inline-block;
    text-align: center;
    width: 24px;
    height: 24px;
    font-size: 17px;
    line-height: 24px;
    border-radius: 100px;
  }

  .title-count.small {
    width: 12px;
    height: 12px;
    font-size: 10px;
    line-height: 12px;
  }

  .drag-over {
    border: solid 2px $grey-8;
  }

  .poster {
    transition: opacity 0.1s;
  }

  .drag-over .poster {
    opacity: 0.2;
  }

</style>
